<template>
  <SectionFrame v-if="files.length" :section="section" :index="index" :heading="section.title || 'Downloads'" label="Downloads" :narrow="true">
    <ul class="s2-files mo-stagger">
      <li v-for="f in files" :key="f.url"><a :href="f.url" class="t-link s2-file" download>
        <span class="s2-file-icon" aria-hidden="true">↓</span><b>{{ f.label || "Download" }}</b></a></li>
    </ul>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const files = computed(() => (Array.isArray(props.section.attachments) ? props.section.attachments : []).filter((f) => f && f.url));
</script>

<style>
.s2-files { list-style: none; padding: 0; margin: 0; display: grid; gap: .5rem; }
.s2-file { display: flex; align-items: center; gap: .9rem; padding: .8rem 1rem; border: 1px solid var(--t-line); border-radius: var(--t-radius-sm); background: var(--t-surface); }
.s2-file:hover { border-color: var(--t-accent); }
.s2-file-icon { display: inline-flex; width: 2rem; height: 2rem; border-radius: 50%; align-items: center; justify-content: center; background: color-mix(in srgb, var(--t-accent) 14%, transparent); color: var(--t-accent); font-weight: 800; }
</style>
